import { theme } from 'antd';

interface PublicationCoverThumbProps {
  url?: string | null;
  /** Square side in px, or any CSS width for a fluid thumb. */
  size: number | string;
  /** Overrides for surfaces that are not the admin's (e.g. phone replicas). */
  background?: string;
  borderRadius?: number;
}

/** Square cover thumb. Tall ebook art stays whole (`contain`) over a
 * blurred, scaled copy of itself, so the fill takes the cover's colours. */
export const PublicationCoverThumb = ({
  url,
  size,
  background,
  borderRadius,
}: PublicationCoverThumbProps) => {
  const { token } = theme.useToken();
  const blur =
    typeof size === 'number' ? Math.max(4, Math.round(size / 7)) : 12;

  return (
    <div
      style={{
        width: size,
        // Fluid widths get their height from the ratio; fixed ones state it,
        // so a stretching flex parent cannot alter the square.
        height: typeof size === 'number' ? size : undefined,
        aspectRatio: 1,
        borderRadius: borderRadius ?? token.borderRadius,
        background: background ?? token.colorFillSecondary,
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {url && (
        <>
          <img
            src={url}
            alt=""
            aria-hidden
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              filter: `blur(${blur}px)`,
              transform: 'scale(1.4)',
            }}
          />
          <img
            src={url}
            alt=""
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </>
      )}
    </div>
  );
};
